module.exports = __webpack_public_path__ + "img/logo.287657c9.png";